/* eslint-disable no-undef */
export const init = () => {
  /*
    SHOPPING TOOL - OPECO
  */

  if (typeof getURLParameter !== 'function') return;

  const url = window.location.href.replace('#', '?');

  const paramType = getURLParameterFromUrlString(url, 'type');
  if (!paramType) return;

  const paramOpeco = getURLParameterFromUrlString(url, paramType);
  if (!paramOpeco) return;

  const datas = paramOpeco.split(':');
  const st = datas[0];
  const std = datas[1];

  CUBE.Analytics.shoppingtool.set(st, std);

  // TODO - Check if other shoppingtools needs to be locked

  // TODO - Is it possible to land directly on a product page with an OPECO ?
};



// WEBPACK FOOTER //
// ./src/analytics/shopping-tool/st-opeco.js